import { dsgvo } from "./dsgvo";

export const globalScenes = [ dsgvo ];
